import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import Hero from './Hero';
import ProtectionTypes from './ProtectionTypes';
import Commitment from './Commitment';
import Security from './Security';
import LockTypes from './LockTypes';
import Protection from './Protection';
import OrgFeatures from './OrgFeatures';
import BrowseSafes from './BrowseSafes';
import StickyNav from './StickyNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class BuyingGuide extends Component {
	render() {
		return (
			<div className="buying-guide">
				<Helmet>
					<title>Learn About Our Safes | SentrySafe</title>
					<meta name="description" content="SentrySafe provides protection for the things that matter most to you. Learn more." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Learn" />
					<BreadcrumbItem label="Buying Guide" />
				</Breadcrumb>

				<StickyNav />

				<Header
					title="Learn about our safes"
					description="Protection for the things that matter to you."
				/>

				<Hero />
				
				<ProtectionTypes />

				<Commitment />
				
				<Security />
				
				<LockTypes />

				<Protection />
				
				<OrgFeatures />

				<BrowseSafes />
			</div>
		);
	}
};

export default BuyingGuide;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Index.js